// frontend/src/axiosConfig.js
import axios from "axios";

// Detectar si estamos en producción
const isProduction = process.env.NODE_ENV === 'production';

// URL base dinámica
const BASE_URL = isProduction 
    ? 'https://brechovizinho.com.br'
    : 'http://localhost:8000';

// Configuración de API
export const API_BASE_URL = `${BASE_URL}/api`;

const instance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // 🔥 CRÍTICO: Enviar cookies en todas las peticiones
  headers: {
    "Accept": "application/json",
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
});

// Variable para controlar si estamos en proceso de login
let isLoginRequest = false;

// 🔥 INTERCEPTOR PARA CSRF Y COOKIES
instance.interceptors.request.use((config) => {
  // Marcar si es una petición de login
  isLoginRequest = config.url?.includes("/auth/login") || false;
  
  // 🔥 NO AGREGAR Authorization manualmente - usar cookies
  // Las cookies se envían automáticamente con withCredentials: true
  
  // 🔥 CSRF Token para Sanctum (leer de la cookie)
  const xsrfToken = getCookie("XSRF-TOKEN");
  if (xsrfToken) {
    config.headers["X-XSRF-TOKEN"] = decodeURIComponent(xsrfToken);
  }
  
  // 🔥 Si hay un token en localStorage (para compatibilidad), enviarlo
  // PERO priorizar las cookies
  const token = localStorage.getItem("token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  return config;
});

// Interceptor para manejar errores
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    // NO redirigir si es un error de login
    if (error.response?.status === 401 && !isLoginRequest) {
      console.log("🔴 Sesión expirada o no autenticado");
      // No redirigir automáticamente, dejar que el AuthContext maneje
    }
    
    // Resetear la bandera
    isLoginRequest = false;
    
    return Promise.reject(error);
  }
);

// Función para leer cookies
function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

export default instance;